import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GivColumnDomain } from 'app/services/domain.service';
import { RCRecordItem, ResoCenterCol } from 'app/services/resolution-center.service';

export interface RCCellChangeData {
	val: any;
	col: ResoCenterCol;
}

@Component({
  selector: 'app-rc-cell',
  templateUrl: './rc-cell.component.html',
  styleUrls: ['./rc-cell.component.css']
})
export class RcCellComponent implements OnInit {

	@Input() column: ResoCenterCol;
	@Input() rcRecordItem: RCRecordItem;
	@Input() domain: GivColumnDomain;
	@Input() isError: boolean;

	@Output() edit: EventEmitter<RCCellChangeData> = new EventEmitter();

	inputType: 'text' | 'number'; // TODO
	constructor() { }

	onEdit() {
		this.edit.emit({
			val: this.rcRecordItem.props[this.column.prop],
			col: this.column
		});
	}

	ngOnInit() {
		this.inputType = (this.column && this.column.lbType === 'number') ? 'number' : 'text';
	}

}
